// extracted by mini-css-extract-plugin
module.exports =  {"campaignCard":"W_SZUowrQLtIPQqd7q5E"};